import React, { Component } from 'react';
import { Pagination } from '@ali/aps-dev';
import '@ali/aps-dev/dist/css/aps.css';
import './domainPagination.scss';
import { inject, observer } from 'mobx-react';

@inject('resultListStore')
@observer
class DomainPagination extends Component {

  handlerPageChange(pageIndex) {
    this.props.resultListStore.fetchresultList({ 'currentPage': pageIndex });
  }

  handlerGetMore() {
    this.props.resultListStore.changePageSize();
    this.props.resultListStore.fetchresultList({
      'pageSize': this.props.resultListStore.pageSize
    });
  }

  render() {
    return (
      <div>
        <div className="domain-pagination">
          <Pagination
            defaultCurrent={this.props.resultListStore.currentPage}
            total={this.props.resultListStore.totalPage}
            showTotal
            pageSize={this.props.resultListStore.pageSize}
            showQuickJumper={true}
            onChange={this.handlerPageChange.bind(this)}
            style={{ paddingRight: 20 }}
          />
        </div>
        <div className="loading">
          {this.props.resultListStore.isLoading &&
            <p onClick={this.handlerGetMore.bind(this)} className="load-more">加载更多</p>
          }
          {this.props.resultListStore.isOver &&
            <p className="overline-text">
              <span className="overline overline-left"></span>
              已经到底啦
              <span className="overline overline-right"></span>
            </p>
          }
        </div>
      </div>
    );
  }
}
export default DomainPagination;


// WEBPACK FOOTER //
// ./src/components/DomainPagination/DomainPagination.js